// AdSense 광고 설정값 + 배치 규칙.
//
// 자동 광고는 콘솔에서 끈 상태다(app/views/shared/_adsense_head.html.erb 주석 참조) —
// 지면은 이 파일이 정하는 슬롯으로만 연다.

export const ADSENSE_CLIENT = 'ca-pub-8125307663464335'

// 게시판/피드 목록 인피드 광고 단위.
export const IN_FEED_SLOT = '3172215903'
export const IN_FEED_LAYOUT_KEY = '-6t+ed+2i-1n-4w'

// 글 상세 본문 아래 디스플레이 광고 단위("axhub 글 상세 본문 아래"). 빈 값이면 AdSlot 이 렌더하지 않는다.
export const ARTICLE_SLOT = '2891773631'

/**
 * 목록의 `index`(0-based) 글 뒤에 인피드 광고를 넣을지 판정한다.
 * 7번째·14번째·21번째… 글 뒤에만 넣는다(공지는 호출부에서 애초에 넘기지 않는다).
 */
export function shouldShowAdAfter(index, total) {
  if (total < 7) return false
  return (index + 1) % 7 === 0
}
